export var PriceBase = {
  fontSize: {
    xs: '18px',
    sm: '20px',
    md: '22px'
  },
  lineHeight: {
    xs: '22px',
    sm: '24px',
    md: '26px'
  }
};